import { Component } from 'react';
import Modal from './Modal';
import check from "../../assets/check.svg";
import equis from "../../assets/eliminar.svg"
import ComponenteContrasenia from './ComponenteContrasenia';
import '../../css/FormAcuerdoAlumni.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import jwt from 'jwt-decode'
import Acuerdo from './Acuerdo.js'
import alarma from "../../assets/alarma.svg";


export class ActualizarArchSolicitud extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalNoExisteEnBase: false,
            IsDataCorrect: false,
            documentosValidos: {
                isvalidimgpersona: "",
                isvalidimgtarjeta: "",
                isvalidcontrato: ""
            },
            datosUsuario: {
                token: "",
                id: "",
                identificacion: "0",
                alias_sugerido: "",
                telefono: "",
                unidad: "",
                rol: "",
                correoAlterno: "",
                nombres: "",
                apellidos: "",
                username: "",
                correo: "",
                usuarioEscogido: "",
                fechaNacimiento: ""
            },
            idSolicitud:"",
            tokendecodeData: {
                nombres_temp: "",
                apellidos_temp: "",
                user_temp: "",
                identificacion_temp: "",
            },
            tokendecodestate: "",
            isPersonalData: false,
            errorsDatosEcu: {
            },
            expresiones: {
                cedula: /^[\d]{10}$/,
                pasaporte: /^[a-zA-Z0-9._]{4,14}$/,
            },
            verificarDatosEcu: {
                cedula: "",
                fechaEmision: "",
                terminos: ""
            },
            activebutton: true,
            modalIngresoDatos:false,
            modalErrorAcuerdoGen: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: equis,
            },
            aceptoAcuerdo: false,
            modalPrevAcuerdoGen: false,
            enlaceAcuerdo: "",
            modalIsOpen: false,
            verBoton: true,
            
            idAcueFirmElec:"",
            contra: {
                contrasena: "",
                contrasenaCumple: false,
                repetirContraCumple: false,
            },
            navigateCas: true,
            modalError: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: ""
            },
            IsSign: false,
        };
        this.abrirModalnoExisteEnBase = this.abrirModalnoExisteEnBase.bind(this);
        this.cerrarModalnoExisteEnBase = this.cerrarModalnoExisteEnBase.bind(this);
        this.handlerOnBlurCedula = this.handlerOnBlurCedula.bind(this);
        this.abrirModalInfo = this.abrirModalInfo.bind(this);
        this.cerrarModalInfo = this.cerrarModalInfo.bind(this);
        this.cerrarModalIngresoDatos = this.cerrarModalIngresoDatos.bind(this);
        this.abrirModalIngresoDatos = this.abrirModalIngresoDatos.bind(this);
        this.cerrarModalErrorGen = this.cerrarModalErrorGen.bind(this);
        this.cerrarModalPrevGen = this.cerrarModalPrevGen.bind(this);
        this.abrirModalPrevGen = this.abrirModalPrevGen.bind(this);
        this.abrirModalError = this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);
        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);
    }

    abrirModalnoExisteEnBase() {
        this.setState({ modalNoExisteEnBase: true });
    }

    cerrarModalnoExisteEnBase() {
        this.setState({ modalNoExisteEnBase: false });
    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });
    }

    cerrarModalErrorGen() {
        this.setState({
            modalErrorAcuerdoGen: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        }, () => {
            this.activebuttonf();
        });
    }

    cerrarModalPrevGen() {
        this.setState({
            modalPrevAcuerdoGen: false,
        });
    }

    abrirModalPrevGen() {
        this.setState({
            modalPrevAcuerdoGen: true,
        });
    }

    abrirModalIngresoDatos() {
        this.setState({ modalIngresoDatos: true })
    }

    cerrarModalIngresoDatos() {
        if (!this.state.isPersonalData || !this.state.modalPrevAcuerdoGen) {
            var servicio = localStorage.getItem('servicio');
            if (servicio !== null || servicio !== undefined) {
                window.location.href = servicio;
            } else {
                window.location.href = 'https://alumni.espol.edu.ec/';
            }
        }
    }

    abrirModalError() {
        this.setState({
            modalError: {
                ...this.state.modalError,
                show: true
            }
        });
    }


    cerrarModalError() {
        this.setState({
            modalError: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
    }

    abrirModalInfo() {
        this.setState({ modalIsOpen: true });
    }

    cerrarModalInfo() {
        this.setState({ modalIsOpen: false });
        this.activarNavigateLogin();
    }

    activarNavigateLogin() {
        window.location.href = "/Inicio";
    }

    getCedulaByUsername = async (e) => {
        var username = this.state.datosUsuario.username;
        if (username !== "") {
            await axios.get(`${process.env.REACT_APP_API}api/CuentaUsuario/getcedulauser/${username}`)
                .then(r => {
                    if (r.status == 200) {
                        this.setState({
                            datosUsuario: {
                                ...this.state.datosUsuario,
                                identificacion: r.data.persona.identificacion,
                            }
                        }, () => {
                            this.setState({ navigateCas: false });
                            if (this.state.datosUsuario.identificacion !== 0) {
                                this.validarFirmaAcuerdo();
                            }
                        })
                    }
                })
                .catch(error => {
                })
        }
    }

    cerrarSesion = async () => {
        Cookies.remove("token");
        Cookies.remove("cas");
        Cookies.remove("DatosPersonalesGIA.CAS");
        window.location.href = "/logout";
    }


    validarFirmaAcuerdo = async (e) => {
        var id_temp = this.state.datosUsuario.identificacion;
        if (id_temp !== "") {
            await axios.get(`${process.env.REACT_APP_API}api/Persona/enlacefirmaacgen/${id_temp}`)
                .then(r => {
                    //console.log("validarFirmaAcuerdo");
                    //console.log(JSON.stringify(r));
                    if (r.status == 200) {
                        //console.log(r.data);
                        this.setState({
                            IsSign: true,
                            enlaceAcuerdo: r.data,
                        })
                    }
                })
                .catch(error => {
                    //console.log(error.message);
                })
        }
    }


    mostrarModalData = async (e) => {
        //this.setState({ modalData: false });
        //console.log("asdasd");
    }

    handlerOnBlurCedula = async (e) => {
        if (!this.state.expresiones.pasaporte.test(this.state.verificarDato)) {
            await this.setState({
                errorsDatosCed: {
                    cedula: "Identificacion debe tener 10 dígitos",
                }
            })
        } else {
            this.setState({ errorsDatosCed: {} })
        }
       
    }

/*
    getVerificarUsuarioEcu = async (e) => {
        e.preventDefault();
        this.disabledbuttonf();
        //console.log(`${process.env.REACT_APP_API}api/Persona/firmarAcuerdoAlumni/${this.state.verificarDatosEcu.cedula}/${this.state.verificarDatosEcu.fechaEmision}`)
        await axios.get(`${process.env.REACT_APP_API}api/Persona/firmarAcuerdoAlumni/${this.state.verificarDatosEcu.cedula}/${this.state.verificarDatosEcu.fechaEmision}`)
            .then(r => {
                if (r.status == 200) {
               // console.log(r.data);
                this.setState({
                    datosUsuario: {
                        ...this.state.datosUsuario,
                        identificacion: r.data.persona.identificacion,
                        nombres: r.data.persona.nombres,
                        apellidos: r.data.persona.apellidos,
                        username: r.data.cuentaUsuario.username,
                    },
                    modalPrevAcuerdoGen: true,
                    isPersonalData: true,
                }, () => {
                    this.activebuttonf();
                    this.cerrarModalIngresoDatos();
                });
               // console.log(this.state.datosUsuario);   
                }
            })
            .catch(error => {
                this.setState({
                    modalErrorAcuerdoGen: {
                        show: true,
                        titulo: "Firma del acuerdo de uso de datos personales y el acuerdo de uso de medios electrónicos - AlumniESPOL",
                        mensaje: error.response.data.errorMessage,
                        imagen: equis,
                    }
                });
               // console.log(error.response.data.errorMessage);
            })
    }*/

    handlerOnBlurEcu = async (e) => {

        if (!this.state.expresiones.cedula.test(this.state.verificarDatosEcu.cedula)) {
            await this.setState({
                errorsDatosEcu: {
                    cedula: "Identificacion debe tener 10 dígitos",
                }
            })
        } else {
            this.setState({ errorsDatosEcu: {} })
        }

    }


    verAcuerdoAlumni() {
        //console.log("ver acuerdo alumni");
    }

    handlerVerificarDatosEcu = async (e) => {


        await this.setState({
            verificarDatosEcu: {
                ...this.state.verificarDatosEcu,
                [e.target.name]: e.target.value,
                terminos: e.target.checked
            }      
        })

        this.handlerOnBlurEcu();
    }


    handlerDatosFormRegistro = async (e) => {
        await this.setState({
            aceptoAcuerdo: e.target.checked,
            
        })
    }



    getDataSolicitud = (e) => {
        try {
            this.setState({
                datosUsuario: {
                    ...this.state.datosUsuario,
                    nombres: this.state.tokendecodestate["Nombres"],
                    apellidos: this.state.tokendecodestate["Apellidos"],
                    username: this.state.tokendecodestate["User"],
                }
            }, () => {
                //console.log(this.state.datosUsuario)


                if (this.state.datosUsuario.identificacion !== "" && this.state.datosUsuario.nombres !== "" && this.state.datosUsuario.apellidos !== "" && this.state.datosUsuario.username !== "") {
                    //console.log("todo es valido");
                    this.setState({
                        IsDataCorrect: true,
                    });
                    //console.log(this.state.datosUsuario);
                    //llamar a la solicictud
                    axios.get(`${process.env.REACT_APP_API}api/Solicitud/getsolicitudRechazada/${this.state.datosUsuario.identificacion}`)
                        .then(r => {
                            //console.log(JSON.stringify(r));
                            if (r.status == 200) {
                                //console.log(r.data);
                                this.setState({
                                    idSolicitud: r.data.idsccesolicitud,
                                    documentosValidos: {
                                        ...this.state.documentosValidos,
                                        isvalidimgpersona: r.data.isvalidimgpersona,
                                        isvalidimgtarjeta: r.data.isvalidimgtarjeta,
                                        isvalidcontrato: r.data.isvalidcontrato
                                    }
                                })
                            }
                        })
                        .catch(error => {
                            //console.log(error.message);
                            this.setState({
                                IsDataCorrect: false,
                            })
                        })
                } else {
                    //console.log("toeo es vacio");
                    this.abrirModalnoExisteEnBase();
                    this.setState({
                        IsDataCorrect: false,
                    })
                }


            })
            
                   
               
        } catch (e) {
            this.setState({
                IsDataCorrect: false,
            });
        }
     
    };


    componentWillMount = () => {
        var ruta = window.location.href;
        var token_temp = ruta.split("token=")[1];
        var tokendecode = jwt(token_temp);
        this.setState({
            tokendecodestate: tokendecode,
        }, () => {
            sessionStorage.setItem("token_nueva_cuenta",token_temp);

            var user_temp = this.state.tokendecodestate["User"];
            axios.get(`${process.env.REACT_APP_API}api/Persona/getCedulaByUsername/${user_temp}`)
                .then(r => {
                    if (r.status == 200) {
                        this.setState({
                            datosUsuario: {
                                ...this.state.datosUsuario,
                                identificacion: r.data.identificacion,
                            }
                        }, () => {
                            this.getDataSolicitud();
                        })
                    }
                });
        })
      

    }

    render() {
        var nombresCompletos = `${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`
        var username = `${this.state.datosUsuario.username}`

        return (
            this.state.IsDataCorrect ?
                (
                    <div>
                        <Acuerdo
                            identificacion={this.state.datosUsuario.identificacion}
                            nombres={this.state.datosUsuario.nombres}
                            apellidos={this.state.datosUsuario.apellidos}
                            alias_sugerido={this.state.datosUsuario.alias_sugerido}
                            usuario_sugerido={this.state.datosUsuario.username}
                            correoAlterno={this.state.datosUsuario.correoAlterno}
                            rol={this.state.datosUsuario.rol}
                            telefono={this.state.datosUsuario.telefono}
                            unidad={this.state.datosUsuario.unidad}
                            tipoForm={"A"}
                            mensaje_titulo="Firma de acuerdo"
                            verbtngeneral={false} //false muestra y true oculta
                            verbtngeneralElectronica={false} //true muestra y false oculta
                            firmadoGeneral={true}
                            tipoAcuerdo={"ActualizarArchSolicitud"}
                            modalPrevAcuerdoGen={false}
                            rectificacionDocs={true}
                            callTagManager={this.props.callTagManager}
                            documentosValidos={this.state.documentosValidos}
                            idSolicitud={this.state.idSolicitud}
                            /*useEffect={this.props.useEffect}*/
                        ></Acuerdo>
                    </div>
                )
                :
                    (
                        <div>
                        <Modal isOpen={this.state.modalNoExisteEnBase} cerrarModal={this.cerrarModalnoExisteEnBase} verBoton={false} textoBoton="ACEPTAR" >
                            <div className='mt-6 mb-6 nacionalidad-modalnocuenta-div' align="center">
                                <img className="nacionalidad-modalnocuenta-logos" src={alarma} alt="Error"></img>
                            </div>
                            <p className='text-center nacionalidad-modalnocuenta-texto '>Se ha verificado su solicitud y<b> no tiene un estado de rechazada. </b></p>
                            <p className="text-center">
                                <strong>Puede comunicarse con Gerencia de Tecnologías y Servicios de Información</strong></p>
                            <div className="text-center inactiva-contacto">
                                <table>
                                    <tr>
                                        <td ><strong>Teléfono: </strong></td>
                                        <td className="nacionalidad-centerTable">(+593) 42269256 </td>
                                    </tr>
                                    <tr>
                                        <td><strong>Atención: </strong></td>
                                        <td className="nacionalidad-centerTable">Lunes a Viernes de 08:00 a 16:00</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Correo: </strong></td>
                                        <td className="nacionalidad-centerTable"><a href="mailto:gerenciatecnologia@espol.edu.ec?" >gerenciatecnologia@espol.edu.ec</a></td>
                                    </tr>
                                </table>
                            </div>

                        </Modal>

                            {this.state.modalErrorAcuerdoGen.show &&
                                <Modal isOpen={this.state.modalErrorAcuerdoGen.show} cerrarModal={this.cerrarModalErrorGen} verBoton={true} textoBoton="ACEPTAR" >
                                    <p className='text-center'><strong>{this.state.modalErrorAcuerdoGen.titulo}</strong></p>
                                    <div align="center">
                                        <img className="registroContra-check" src={this.state.modalErrorAcuerdoGen.imagen} alt="Exitoso"></img>
                                    </div>
                                    <p className='text-center'>{this.state.modalErrorAcuerdoGen.mensaje}</p>
                                </Modal>
                            }

                        </div>

                    )
        )
    }
}

export default ActualizarArchSolicitud
